/* Rail card photos that wait until the card is in view (snippets/product-card.liquid with defer: true, set by
   snippets/product-rail-track.liquid for every card past the ones loaded with the page).
   A deferred <img data-deferred> keeps its files in data-defer-srcset / data-defer-src. Once its rail comes within
   a short distance of the screen, the rail gets its own observer: a card counts when it is inside the rail or
   about half a rail ahead to the right, so on phones the cards in view and the next one load, and the rest wait for a
   swipe. On desktop the rail is a plain 6-card grid, so its 6 visible cards load and the hidden ones never do.
   Rails added later (assets/product-rail.js, recently viewed, the product page's rails) are picked up as they are
   inserted. Without IntersectionObserver every photo loads; without JavaScript the card's <noscript> copy shows. */
(() => {
  if (window.LMBRailImages) return;
  window.LMBRailImages = true;

  const show = (img) => {
    if (!img.hasAttribute('data-deferred')) return;
    if (img.dataset.deferSrcset) img.setAttribute('srcset', img.dataset.deferSrcset);
    if (img.dataset.deferSrc) img.setAttribute('src', img.dataset.deferSrc);
    img.removeAttribute('data-deferred');
  };

  if (!('IntersectionObserver' in window)) {
    const all = () => document.querySelectorAll('img[data-deferred]').forEach(show);
    all();
    new MutationObserver(all).observe(document.documentElement, { childList: true, subtree: true });
    return;
  }

  const watched = new WeakSet();

  // One observer per rail, rooted at the rail itself, so cards hidden sideways don't count until they come close.
  const watchCards = (track) => {
    const cards = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          cards.unobserve(entry.target);
          show(entry.target);
        });
      },
      { root: track, rootMargin: '0px 50% 0px 0px' }
    );
    track.querySelectorAll('img[data-deferred]').forEach((img) => cards.observe(img));
  };

  // Rails start their card observer only once they are near the screen.
  const rails = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        rails.unobserve(entry.target);
        watchCards(entry.target);
      });
    },
    { rootMargin: '200px 0px' }
  );

  // A deferred photo outside any rail (not expected) simply loads near the screen.
  const loose = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loose.unobserve(entry.target);
        show(entry.target);
      });
    },
    { rootMargin: '200px 0px' }
  );

  const scan = (root) => {
    // Rails fetched as HTML (Section Rendering, recommendations) are parsed without scripting, so their no-JS photo
    // copies arrive as real images: drop them, JavaScript is running.
    root.querySelectorAll('[data-rail-track] noscript').forEach((copy) => copy.remove());
    root.querySelectorAll('img[data-deferred]').forEach((img) => {
      const track = img.closest('[data-rail-track]');
      if (track) {
        if (!watched.has(track)) {
          watched.add(track);
          rails.observe(track);
        }
      } else if (!watched.has(img)) {
        watched.add(img);
        loose.observe(img);
      }
    });
  };

  scan(document);
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node.matches && node.matches('img[data-deferred]') ? node.parentElement || node : node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
